import { useEffect, useState } from 'react'

import { last } from '~/utils'

export default function useFileBlob(assetUrl: string): { blobUrl: string; filename: string } {
  const [blobUrl, setBlobUrl] = useState('')
  const filename = last(assetUrl.split('/')) as string

  useEffect(() => {
    void (async () => {
      const resp = await fetch(assetUrl)
      const blob = await resp.blob()

      setBlobUrl(URL.createObjectURL(blob))
    })()
  }, [assetUrl])

  return {
    blobUrl,
    filename,
  }
}
